// constants.js
// Created: 2026-03-11 14:30:00 EST
// Updated: 2026-03-11 14:30:00 EST
// Project: Giving Words to Voices
// Author: Michael Schwarz
// Version: 1.0.0

// Backend URL: set REACT_APP_BACKEND_URL in your .env to override.
// In production we prefer the frontend nginx reverse proxy path.
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '/api';

// Video files are served by a dedicated nginx container and reverse-proxied
// through the frontend in production.
export const VIDEO_SERVER_URL = process.env.REACT_APP_VIDEO_SERVER_URL || '';

// Idle timeout warning — seconds before auto-logout to show the warning overlay.
export const WARNING_SECS = 30;

// Default idle timeout values per role (minutes; 0 = disabled).
export const DEFAULT_IDLE_TIMEOUT = {
  admin:  0,
  editor: 30,
  viewer: 20,
};

// Pipeline stage definitions.
// Each entry: [id, label, level, optional]
//   level    — "part" (per tape/part) or "interview" (once per project)
//   optional — true = stage can be skipped without blocking progress
export const PIPELINE_STAGES = [
  [1, 'Transcribe',      'part',      false],
  [2, 'Translate',       'part',      true ],
  [3, 'Review & Mark',   'part',      false],
  [4, 'Re-proof',        'part',      true ],
  [5, 'Generate Output', 'part',      false],
  [6, 'QA Review',       'interview', false],
  [7, 'Clips & QR',      'interview', true ],
  [8, 'Final Review',    'interview', false],
  [9, 'Complete',        'interview', false],
];

export const PART_STAGES      = PIPELINE_STAGES.filter(s => s[2] === 'part');
export const INTERVIEW_STAGES = PIPELINE_STAGES.filter(s => s[2] === 'interview');

export const NUDGES = [
  { label: '±0.1s', v: 0.1 },
  { label: '±0.5s', v: 0.5 },
  { label: '±1s',   v: 1.0 },
  { label: '±2s',   v: 2.0 },
];

export const QR_TEMPLATES = [
  {
    id: 'classic',
    name: 'Classic',
    desc: 'Clean black on white',
    swatch: { bg: '#ffffff', fg: '#000000' },
    style: { fg_color: '#000000', bg_color: '#ffffff', corner_style: 'square', error_correction: 'H', quiet_zone: 4, logo_data: '', logo_size_pct: 0.27 },
  },
  {
    id: 'memorial-dark',
    name: 'Memorial Dark',
    desc: 'White on deep navy',
    swatch: { bg: '#1a1a2e', fg: '#ffffff' },
    style: { fg_color: '#ffffff', bg_color: '#1a1a2e', corner_style: 'rounded', error_correction: 'H', quiet_zone: 4, logo_data: '', logo_size_pct: 0.27 },
  },
  {
    id: 'sepia',
    name: 'Sepia Archive',
    desc: 'Warm archival tones',
    swatch: { bg: '#f5f0e8', fg: '#3d1c02' },
    style: { fg_color: '#3d1c02', bg_color: '#f5f0e8', corner_style: 'square', error_correction: 'H', quiet_zone: 4, logo_data: '', logo_size_pct: 0.27 },
  },
  {
    id: 'indigo',
    name: 'Indigo',
    desc: 'White on indigo with dots',
    swatch: { bg: '#4f46e5', fg: '#ffffff' },
    style: { fg_color: '#ffffff', bg_color: '#4f46e5', corner_style: 'dots', error_correction: 'H', quiet_zone: 4, logo_data: '', logo_size_pct: 0.27 },
  },
  {
    id: 'forest',
    name: 'Forest',
    desc: 'White on deep green',
    swatch: { bg: '#1a3a2a', fg: '#e8f5ee' },
    style: { fg_color: '#e8f5ee', bg_color: '#1a3a2a', corner_style: 'rounded', error_correction: 'H', quiet_zone: 4, logo_data: '', logo_size_pct: 0.27 },
  },
  {
    id: 'print',
    name: 'Print Ready',
    desc: 'Max contrast for print',
    swatch: { bg: '#ffffff', fg: '#000000' },
    style: { fg_color: '#000000', bg_color: '#ffffff', corner_style: 'dots', error_correction: 'H', quiet_zone: 6, logo_data: '', logo_size_pct: 0.27 },
  },
];

export const MARKER_TEMPLATES = [
  {
    id: 'plaque',
    name: 'Plaque',
    desc: 'Horizontal bronze plaque — modern cemeteries & memorial walls',
    width: 600, height: 360,
    bg: '#2a1f14', textColor: '#d4a96a', borderColor: '#8b6d3f',
    shape: 'rect', borderRadius: 12,
  },
  {
    id: 'headstone',
    name: 'Headstone',
    desc: 'Traditional upright tombstone with arched top',
    width: 400, height: 560,
    bg: '#6b6b6b', textColor: '#e8e8e8', borderColor: '#888',
    shape: 'arch', borderRadius: 0,
  },
  {
    id: 'wall-tile',
    name: 'Wall Tile',
    desc: 'Square memorial wall tile — compact & dignified',
    width: 400, height: 400,
    bg: '#1a1a2e', textColor: '#c8c8d8', borderColor: '#3a3a5e',
    shape: 'rect', borderRadius: 4,
  },
  {
    id: 'modern',
    name: 'Modern',
    desc: 'Minimal contemporary rectangle — light & clean',
    width: 560, height: 320,
    bg: '#f8f6f3', textColor: '#1a1a1a', borderColor: '#ccc',
    shape: 'rect', borderRadius: 8,
  },
];
